import * as Sentry from '@sentry/browser';

export const initSentry = () => {
  Sentry.init({
    dsn: process.env.PUBLIC_SENTRY_DSN,
    environment: process.env.PUBLIC_APP_ENV,

    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.dedupeIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  });

};

export { Sentry };
